import { render, staticRenderFns } from "./DocumentContent.vue?vue&type=template&id=35e5d6b2&scoped=true&"
import script from "./DocumentContent.vue?vue&type=script&lang=js&"
export * from "./DocumentContent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentContent.vue?vue&type=style&index=0&id=35e5d6b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e5d6b2",
  null
  
)

export default component.exports